var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filters-preview" }, [
    _c(
      "ul",
      _vm._l(_vm.activeFilters, function(filter, index) {
        return _c(
          "li",
          { key: index },
          [
            _c("div", {
              staticClass:
                "filters-preview__tag typographies-paragraph-medium-regular",
              domProps: {
                innerHTML: _vm._s(_vm.$filters.stripTags(filter.translation))
              },
              on: {
                click: function($event) {
                  return _vm.editFilter(filter)
                }
              }
            }),
            _vm._v(" "),
            _vm.filterEditable(filter) && filter.deletable
              ? _c("CompassIconButton", {
                  attrs: { icon: "close", size: "small" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.$store.dispatch(
                        _vm.listinghash + "/removeFilter",
                        filter
                      )
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }